import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { generatePadding, mediaQuery } from '@lacedltd/laced-components'

export const ProductHeroWrapper = styled.div({
  marginBottom: '0',

  [mediaQuery.m.min]: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '0 1.25rem',
    maxWidth: '1184px',
    margin: 'auto'
  }
})

export const ProductHeroImages = styled.div({
  alignItems: 'center',
  display: 'flex',
  flex: 'auto',
  flexDirection: 'column',
  margin: `0 auto ${tokens.spacing[6]}`,
  width: '100%',

  [mediaQuery.m.min]: {
    padding: 0,
    margin: `${tokens.spacing[7]} auto`,
    position: 'sticky',
    top: '4.5rem', // so that on scroll it appears below the header
    width: '60%'
  },

  '> div ': {
    width: '100%'
  }
})

export const ProductHeroInfo = styled.div({
  maxWidth: '100%',

  [mediaQuery.m.max]: {
    padding: `0 ${tokens.spacing[6]}`
  },

  [mediaQuery.m.min]: {
    paddingTop: tokens.spacing[7],
    width: '420px'
  }
})

export const CarouselContainer = styled.div({
  maxWidth: '1184px',
  width: '100%',
  margin: '0 auto',
  padding: generatePadding('spacing.9', 'spacing.6', 'spacing.12'),

  [mediaQuery.m.min]: {
    padding: generatePadding('spacing.9', 'spacing.8', 'spacing.12')
  }
})
